import { render, staticRenderFns } from "./EmploymentEditList.vue?vue&type=template&id=63070e1c&"
import script from "./EmploymentEditList.vue?vue&type=script&lang=ts&"
export * from "./EmploymentEditList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports